const footerNavGroups = [
  {
    title: '热门分类',
    links: [
      { label: '韩漫恋爱', href: '#cards' },
      { label: '日漫悬疑', href: '#cards' },
      { label: '国漫玄幻', href: '#cards' },
      { label: '完结经典', href: '#ranking' },
    ],
  },
  {
    title: '帮助中心',
    links: [
      { label: '常见问题', href: '#faq' },
      { label: '关于我们', href: '#about' },
      { label: '联系投稿', href: '#contact' },
      { label: '漫画索引', href: '#index' },
    ],
  },
  {
    title: '精彩内容',
    links: [
      { label: '焦点专题', href: '#carousel' },
      { label: '人气排行', href: '#ranking' },
      { label: '更新动态', href: '#updates' },
      { label: '精彩集锦', href: '#media' },
    ],
  },
];

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          <div className="col-span-2 md:col-span-1">
            <a
              href="#hero"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="inline-flex items-center gap-2 mb-4"
            >
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-read-line text-background-50 text-lg"></i>
              </div>
              <span className="text-lg font-bold text-background-50" style={{ fontFamily: 'var(--font-heading)' }}>
                虫虫漫画
              </span>
            </a>
            <p className="text-xs text-background-400 leading-relaxed mb-4 max-w-[260px]">
              虫虫漫画（曾用名汗汗虫虫漫画）是深受漫画爱好者喜爱的免费在线漫画平台。
              涵盖韩漫、日漫、国漫三大品类，提供流畅的下拉式阅读体验。汗汗漫画、虫虫汗汗等老用户入口持续可用。
            </p>
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-background-300 cursor-pointer hover:bg-primary-500 hover:text-background-50 transition-colors">
                <i className="ri-wechat-line"></i>
              </div>
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-background-300 cursor-pointer hover:bg-primary-500 hover:text-background-50 transition-colors">
                <i className="ri-weibo-line"></i>
              </div>
            </div>
          </div>

          {footerNavGroups.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-background-50 mb-3">{group.title}</h4>
              <ul className="space-y-2">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      onClick={(e) => {
                        e.preventDefault();
                        document.querySelector(link.href)?.scrollIntoView({ behavior: 'smooth' });
                      }}
                      className="text-xs text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-800 pt-6">
          <div className="mb-4">
            <h4 className="text-xs font-semibold text-background-300 mb-2">合作伙伴</h4>
            <p className="text-xs text-background-500">虚位以待，诚邀优质漫画平台与内容创作者加入合作</p>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} 虫虫漫画 - 汗汗虫虫漫画. 韩漫日漫国漫免费下拉式在线阅读平台.
            </p>
            <div className="flex items-center gap-4">
              <a
                href="#faq"
                onClick={(e) => { e.preventDefault(); document.querySelector('#faq')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="text-xs text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap"
              >
                常见问题
              </a>
              <a
                href="#contact"
                onClick={(e) => { e.preventDefault(); document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="text-xs text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap"
              >
                联系我们
              </a>
              <a
                href="#hero"
                onClick={(e) => { e.preventDefault(); document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="text-xs text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap"
              >
                返回顶部
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}